import { Spin } from "antd";
import { FontFa, Table } from "../../../components";
import { useRecentDistributionDocument } from "../hooks/use-recent-distribution-document";
import dayjs from "dayjs";
import { DateFormat } from "../../../constants";
import React, { useRef } from "react";
import { Button } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { Routes } from "../../../AppRoutes";
import { useSearchParams } from "../../../hook/use-search-params";

export const RecentDistributionDocument = ({ setSelectedDocument }: { setSelectedDocument: React.Dispatch<any> }) => {
  const { data, isLoading } = useRecentDistributionDocument();
  const history = useHistory();
  const scrollTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const { searchParams, replaceSearchParams } = useSearchParams();

  const goToDetail = (record: any) => {
    history.push(
      Routes.documentDetail.path.replace(
        ":id",
        `${record.docWorkingId}?action=info&status=publish&fileId=${record.id}`,
      ),
    );
  };

  const handleRowClick = (record: any) => {
    searchParams.delete("mode");
    replaceSearchParams(searchParams);
    setSelectedDocument(record); // handle row click

    if (scrollTimeoutRef.current) {
      clearTimeout(scrollTimeoutRef.current);
    }

    // Set a new scroll timeout
    scrollTimeoutRef.current = setTimeout(() => {
      const target = document.querySelector(".box-statistic");
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 500);
  };

  const columns: any[] = [
    {
      title: "",
      key: "action",
      render: (_: any, record: any) => (
        <Button
          title="Xem thông tin tài liệu"
          onClick={(e) => {
            e.stopPropagation();
            goToDetail(record);
          }}
          className="mr-2"
          variant="outline-success"
        >
          <FontFa name="faInfoCircle" size="sm" />
        </Button>
      ),
      width: 50,
    },
    {
      title: "Id",
      dataIndex: "id",
      key: "id",
      width: 120,
      align: "center",
    },
    {
      title: "Mã tài liệu",
      dataIndex: "docCode",
      key: "docCode",
      width: 120,
    },
    {
      title: "Tên tài liệu",
      dataIndex: "Title",
      key: "Title",
      width: 120,
    },
    {
      title: "Loại tài liệu",
      dataIndex: "docType",
      key: "docType",
      width: 120,
    },
    {
      title: "Tình trạng",
      dataIndex: "docStatus",
      key: "docStatus",
      width: 120,
    },
    {
      title: "Hiệu lực từ",
      dataIndex: "effectiveFrom",
      key: "effectiveFrom",
      width: 120,
      render: (date: Date) => dayjs(date).format(DateFormat.DD_MM_YYYY_HH_MM),
    },
    {
      title: "Lần ban hành",
      dataIndex: "docPublishViewVersion",
      key: "docPublishViewVersion",
      width: 120,
      align: "center",
    },
    {
      title: "Lần sửa đổi",
      dataIndex: "docEditionVersion",
      key: "docEditionVersion",
      width: 120,
      align: "center",
    },
    {
      title: "Người tạo",
      dataIndex: "creator",
      key: "creator",
      width: 120,
    },
    {
      title: "Ngày cập nhật",
      dataIndex: "lastModifiedDateTime",
      key: "lastModifiedDateTime",
      width: 120,
      render: (date: Date) => dayjs(date).format(DateFormat.DD_MM_YYYY_HH_MM),
    },
  ];

  if (isLoading) return <Spin />;

  return (
    <Table
      dataSource={data}
      columns={columns}
      pagination={{ pageSize: 5 }}
      onRow={(record) => {
        return {
          onClick: (event) => handleRowClick(record),
          title: "Click để xem thống kê",
          style: { cursor: "pointer" },
        };
      }}
    />
  );
};
